export function parseCommaList(value: string | null | undefined): string[] {
  if (!value) return [];
  return value.split(",").filter(Boolean);
}

export function serializeCommaList(values: string[] | null | undefined): string {
  if (!values?.length) return "";
  return values.join(",");
}

export function buildCheckboxState(
  keys: string[],
  activeKeys: string[],
): Record<string, boolean> {
  return keys.reduce(
    (acc, key) => {
      acc[key] = activeKeys.includes(key);
      return acc;
    },
    {} as Record<string, boolean>,
  );
}

export function getActiveCheckboxKeys(state: Record<string, boolean>): string[] {
  return Object.keys(state).filter((key) => state[key]);
}

export function parseDateParam(value: string | null | undefined): Date | null {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}
